"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var OfflineConfigStore_1 = __importDefault(require("./OfflineConfigStore"));
var OfflineClientSettings_1 = __importDefault(require("./OfflineClientSettings"));
var InMemoryConfigStorage_1 = __importDefault(require("./storage/InMemoryConfigStorage"));
var ConfigParser_1 = __importDefault(require("./parser/ConfigParser"));
var OfflineAsyncClientSettings_1 = __importDefault(require("./OfflineAsyncClientSettings"));
/**
 * {@link OfflineConfigManager} constructs offline type-safe client instances.
 *
 * <p>Customers can create a {@link OfflineConfigManager} and use it to create offline
 * type-safe clients as needed.
 * The offline type-safe clients created by the same instance of {@link OfflineConfigManager}
 * using the same type will share the same {@link ./storage/FeatureStorage.ts FeatureStorage}.
 *
 * <p>You need to create an instance:
 * <pre>
 *     OfflineConfigManager configManager = new OfflineConfigManager();
 * </pre>
 *
 * <p>You can setup ACS query context provider and interceptors:
 * <pre>
 *     configManager.setQueryContextProvider(myQueryContextProvider);
 *     configManager.addInterceptor(myInterceptor);
 * </pre>
 *
 * <p>And create your type-safe client:
 * <pre>
 *     MyTypeSafeClient typeSafeClient = configManager.createClient(
 *         new MyTypeSafeClientProvider()
 *     );
 * </pre>
 */
var OfflineConfigManager = /** @class */ (function (_super) {
    __extends(OfflineConfigManager, _super);
    function OfflineConfigManager() {
        var _this = _super.call(this) || this;
        _this.configStorage = new InMemoryConfigStorage_1.default();
        return _this;
    }
    OfflineConfigManager.prototype.createClient = function (typeSafeClientProvider, configLoader, offlineClientSettings) {
        var configStore = this.createConfigStore(typeSafeClientProvider, configLoader, offlineClientSettings !== null && offlineClientSettings !== void 0 ? offlineClientSettings : new OfflineClientSettings_1.default());
        var configSet = this.createConfigSet(configStore);
        return typeSafeClientProvider.createTypeSafeClient(configSet);
    };
    OfflineConfigManager.prototype.createUntypedClient = function (typeSafeClientProvider, configLoader, offlineClientSettings) {
        var configStore = this.createConfigStore(typeSafeClientProvider, configLoader, offlineClientSettings !== null && offlineClientSettings !== void 0 ? offlineClientSettings : new OfflineClientSettings_1.default());
        return this.createConfigSet(configStore);
    };
    OfflineConfigManager.prototype.createAsyncClient = function (typeSafeClientProvider, configLoader, offlineClientSettings) {
        var configStore = this.createConfigStore(typeSafeClientProvider, configLoader, offlineClientSettings !== null && offlineClientSettings !== void 0 ? offlineClientSettings : new OfflineAsyncClientSettings_1.default());
        var configSet = this.createAsyncConfigSet(configStore);
        return typeSafeClientProvider.createTypeSafeAsyncClient(configSet);
    };
    OfflineConfigManager.prototype.createUntypedAsyncClient = function (typeSafeClientProvider, configLoader, offlineClientSettings) {
        var configStore = this.createConfigStore(typeSafeClientProvider, configLoader, offlineClientSettings !== null && offlineClientSettings !== void 0 ? offlineClientSettings : new OfflineAsyncClientSettings_1.default());
        return this.createAsyncConfigSet(configStore);
    };
    OfflineConfigManager.prototype.createConfigStore = function (typeSafeClientProvider, configLoader, offlineClientSettings) {
        var _this = this;
        return new OfflineConfigStore_1.default(this.configStorage.computeIfAbsent(typeSafeClientProvider.TABLE_NAME, offlineClientSettings.getStage(), function () { return _this.getFeatureStorage(typeSafeClientProvider, configLoader, offlineClientSettings.getStage()); }), typeSafeClientProvider.CONTEXTUAL_PARAMETERS, offlineClientSettings.getWeblabRulesResolver());
    };
    OfflineConfigManager.prototype.getFeatureStorage = function (typeSafeClientProvider, configLoader, stage) {
        return new ConfigParser_1.default().parse(typeSafeClientProvider, configLoader.load(stage, typeSafeClientProvider.TABLE_NAME));
    };
    return OfflineConfigManager;
}(amazon_config_store_type_script_client_1.ConfigManager));
exports.default = OfflineConfigManager;
